enum BaseURL {
    QA = 'https://audience.qa.adultswim.com',
    PROD = 'https://audience.adultswim.com',
}

export default BaseURL;
